import { http, normalizePage } from '@shared/api';
import type { Page, UUID } from '@shared/api';
import type { AdminUserSearchView, UserBasic, UserSearchFilters } from './types';

function toSearchParams(filters: UserSearchFilters): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: filters.page ?? 0,
    size: filters.size ?? 20,
  };
  if (filters.email) params.email = filters.email;
  if (filters.phone) params.phone = filters.phone;
  if (filters.role) params.role = filters.role;
  if (filters.blocked != null) params.blocked = String(filters.blocked);
  if (filters.kyc) params.kyc = filters.kyc;
  if (filters.q) params.q = filters.q;
  return params;
}

export const userApi = {
  search: async (filters: UserSearchFilters): Promise<Page<AdminUserSearchView>> => {
    const raw = await http.get('users', { searchParams: toSearchParams(filters) }).json<unknown>();
    return normalizePage<AdminUserSearchView>(raw);
  },

  getBasic: (id: UUID) => http.get(`users/${id}/basic`).json<UserBasic>(),

  getBasicBatch: (ids: UUID[]) =>
    http.get('users/basic', { searchParams: { ids: ids.join(',') } }).json<UserBasic[]>(),

  block: (id: UUID, reason: string) =>
    http.post(`users/${id}/block`, { json: { reason } }).json<void>(),

  unblock: (id: UUID) => http.post(`users/${id}/unblock`).json<void>(),
};
